import React, { useState } from "react";
import { OrderFlow } from "../../../App";
//bootstrap
import Modal from "react-bootstrap/Modal";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Image } from "react-bootstrap";
//bootstrap icons
import { GrFormClose } from "react-icons/gr";
//css
import "./css/activation.scss";
import Suceess from "./img/suceess.gif"
const ActivationPopup=()=>{
    const { activatedPopup,
        setActivatedPopup,}=OrderFlow();
        const [successShow,setSuccessShow]=useState(false);
        const [inputValue,setInputValue]=useState('');
        const [showNoValidEmail,setShowNoValidEmail]=useState(false);
        const [error,setError]=useState(null);
        const handleEmail=(e)=>{
          setError(null);
          const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;
          const values = e?.target?.value;
          const emailAddresses = values.match(emailRegex);
          console.log(emailAddresses);
          if(emailAddresses){
            setShowNoValidEmail(true);
            setInputValue(values);
          }else{
            setShowNoValidEmail(false);
          } 
        }
        const handleSubmit=(e)=>{
        
          e.preventDefault();
         console.log(showNoValidEmail);
         if(showNoValidEmail){
          setSuccessShow(true);
         }else{
          if(inputValue){
            setError("Plase Enter Email Address");
          }
          else{
            
            setError("Invalid Email");
          }
         }
        }
        const handleClosePopup=()=>{
          setActivatedPopup(false);
          setSuccessShow(false);
        }
    return(
        <>
         <Modal
        centered
        show={activatedPopup}
        onHide={handleClosePopup}
        backdrop="static"
        keyboard={false}
        id="activationPopup"
      >
        <Modal.Body>
          <>
          <span className="close-btn" onClick={handleClosePopup}>
                  <GrFormClose />
          </span>
          {!successShow &&
          <Modal.Title>
            Account deletion
          </Modal.Title>}
          
         
          {!successShow &&
          <form onSubmit={handleSubmit}>
           <Form.Group className="mb-3" controlId="formBasicEmail">
    <Form.Text>
      by deleting your account <br />
      You can no longer access your account on FusionPos <br />
      You will not be able to recover your account <br />
      Order history will get erased <br />
      Your address history will be deleted <br />
    </Form.Text>
    <Form.Control type="email" placeholder={error ? error : "Enter Email"} style={{color:error?'red':'','::placeholder': error ? 'red' : '',border:error?'1px solid #eb4132':''}} onChange={(e)=>handleEmail(e)}/>
           </Form.Group>
           <Button variant="success" type="submit" >
             Submit
           </Button>
          </form>}
          {successShow && <Image src={Suceess} style={{width:'100%',height:'50%'}}/>}
          {successShow &&<Modal.Title style={{textAlign:'center'}}>Account Deletion</Modal.Title>}
          {successShow && <Form.Text style={{textAlign:'center'}}> As Request, your account will be deleted within 2-3 days,Please Check Your Email Address information</Form.Text>}
          </>
        </Modal.Body>
      </Modal>
        </>
    )
}
export default ActivationPopup;